var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 233,
    viewBox: "0 0 233 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2551_16998)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.623 43.9095C146.488 42.6963 144.902 42.0078 143.241 42.0078H47.002C43.6882 42.0078 41.002 44.6941 41.002 48.0078V111.008C41.002 114.322 43.6882 117.008 47.002 117.008H50.002C53.3157 117.008 56.002 114.322 56.002 111.008V63.0078C56.002 59.6941 58.6882 57.0078 62.002 57.0078H125.002C128.316 57.0078 131.002 59.6941 131.002 63.0078V96.0078C131.002 99.3215 133.688 102.008 137.002 102.008H170.002C173.316 102.008 176.002 104.694 176.002 108.008V111.008C176.002 114.322 178.688 117.008 182.002 117.008H185.002C188.316 117.008 191.002 114.322 191.002 111.008V92.6612C191.002 91.1394 190.424 89.6744 189.384 88.5629L147.623 43.9095Z",
    fill: "#47AD1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.386 155.343C83.386 168.144 74.8999 172.675 62.8179 172.675H55.8421V189H42.1061V138.659H63.7528C75.5471 138.659 83.386 143.189 83.386 155.343ZM69.5062 155.559C69.5062 152.251 67.8521 150.021 63.3933 150.021H55.8421V161.312H63.1775C67.7082 161.312 69.5062 159.37 69.5062 155.559ZM138.022 163.542C138.022 182.456 128.672 189 110.837 189H94.5122V138.659H112.132C127.953 138.659 138.022 144.628 138.022 163.542ZM123.71 163.757C123.71 154.48 120.762 150.597 112.06 150.597H108.608V177.062H111.628C120.33 177.062 123.71 173.754 123.71 163.757ZM189.85 150.525H163.888V157.501H179.638V169.295H163.888V189H150.009V138.659H189.85V150.525Z",
    fill: "#47AD1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2551_16998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(41 42)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/Pdf.ef2997fcf10c5faf0804fdeef063c172.svg";
export { ForwardRef as ReactComponent };